<template>
    <div class="main">
        <!-- channel banner -->
        <div class="cbanner">
            <img src="../../assets/images/banner_ucenter.jpg" />
            <div class="btext">
                <h3>修改密码</h3>
                <p>最低投资成本，最好的安全保证，专业互联网借贷信息中介平台</p>
            </div>
        </div><!-- channel banner END-->
        <div class="main_inner">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <span class="btitle">当前位置：</span>
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>用户中心</el-breadcrumb-item>
                <el-breadcrumb-item>修改密码</el-breadcrumb-item>
            </el-breadcrumb>
            <el-row>
                <el-col :span="5" class="leftside">
                    <el-menu
                            default-active="2"
                            class="el-menu-vertical-demo"
                    >
                        <router-link :to="{ path: '/personalInformation' }">
                            <el-menu-item index="1"><span slot="title" >个人信息</span></el-menu-item>
                        </router-link>
                        <router-link :to="{ path: '/passwordEdit' }">
                            <el-menu-item index="2"><span slot="title">修改密码</span></el-menu-item>
                        </router-link>
                        <router-link :to="{ path: '/myBorrow' }">
                            <el-menu-item index="3"><span slot="title">我的借贷</span></el-menu-item>
                        </router-link>
                    </el-menu>
                </el-col>
                <el-col :span="19">
                    <div class="con_right">
                        <div class="con">
                            <el-form ref="form" :model="form" :rules="editFormRules" class="el-form-self">

                                <el-row>
                                    <el-col>
                                        <el-form-item label="原密码:" prop="password" labelWidth="100px">
                                            <el-input type="password" v-model="form.password" placeholder="请输入原密码"></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>

                                <el-row>
                                    <el-col>
                                        <el-form-item label="新密码:" prop="newPassword" labelWidth="100px">
                                            <el-input type="password" v-model="form.newPassword" placeholder="请输入新密码"></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>

                                <el-row>
                                    <el-col>
                                        <el-form-item label="确认新密码:" prop="confirmNewPassword" labelWidth="100px">
                                            <el-input type="password" v-model="form.confirmNewPassword" placeholder="请输入确认新密码"></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>


                                <el-row class="form-buttons">
                                    <el-form-item class="el-form-item-self" labelWidth="100px">
                                        <el-button type="primary" @click="getPasswordEdit">修改</el-button>
                                    </el-form-item>
                                </el-row>

                            </el-form>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>
    </div>
</template>
<script>
    import  {reqPasswordEdit,reqWebUserOne} from "../../api/webUser-api"
    export default {
        data(){
            return{
                educationArray:[],
                form:{
                    id:'',
                    password:'',
                    newPassword:'',
                    confirmNewPassword:'',
                },
                type:'',
                editFormRules: {
                    password: [
                        {required: true, message: '请输入旧密码', trigger: 'blur'},
                    ],
                    newPassword: [
                        {required: true, message: '请输入新密码', trigger: 'blur'},
                        {
                            pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}$/,
                            message: '密码由字母和数字组成6到16个字符',
                            trigger: 'blur'
                        },
                    ],
                    confirmNewPassword: [
                        {required: true,message: '请输入确认新密码', trigger: 'blur'},
                    ],
                }
            }
        },
        methods:{
            getPersonalInformation() {
                var id = window.sessionStorage.getItem('Authorization');
                reqWebUserOne({id: id}).then((res) => {
                    if (res.data.code === 1) {
                       this.type=res.data.data.type;
                    }
                });
            },
            getPasswordEdit(){
                var that=this;
                this.$refs.form.validate((valid) => {
                    if (valid) {
                        var id=window.sessionStorage.getItem('Authorization');
                        this.form.id=id;
                        let param = Object.assign({}, this.form);
                        reqPasswordEdit(param).then((res)=>{
                            if(res.data.code==0){
                                that.$message({
                                    message: '原密码错误',
                                    type: 'error'
                                });
                            }
                            if(res.data.code==1){
                                that.$message({
                                    message: '原密码和新密码不能相同',
                                    type: 'error'
                                });
                            }
                            if(res.data.code==2){
                                that.$message({
                                    message: '两次密码不相同',
                                    type: 'error'
                                });

                            }
                            if(res.data.code==4){
                                that.$message({
                                    message: '密码修改失败',
                                    type: 'error'
                                });
                            }
                            if(res.data.code==3){
                                that.$message({
                                    message: '密码修改成功',
                                    type: 'success'
                                });
                                window.sessionStorage.removeItem("Authorization");
                                that.$router.push({path:'/login'});
                            }
                        })
                    } else {
                    return false;
                }
            });
                },
        },
        mounted(){
            this.getPersonalInformation()
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/userCenter/PasswordEdit.vue